import React from "react"
import "./AiChatbotDevFeature.css"

const AiChatbotDevFeature = () => {
  const industries = [
    {
        title: "E-commerce",
        description:
          "Improve customer engagement, guide users through product selections, and provide personalized shopping experiences.",
        icon: (
          <i
            className="icon-ai-ml-development-services-e-commerce"
            style={{
              fontSize: "var(--icon-size)",
              width: "var(--icon-size)",
              height: "var(--icon-size)",
            }}
          />
        ),
      },
    {
      title: "Healthcare",
      description:
        "Use AI chatbots for appointment scheduling, patient query handling, and delivering health advice or reminders.",
      icon: (
        <i
          className="icon-ai-ml-development-services-healthcare"
          style={{
            fontSize: "var(--icon-size)",
            width: "var(--icon-size)",
            height: "var(--icon-size)",
          }}
        />
      ),
    },
    {
      title: "Finance",
      description:
        "Offer 24/7 customer support, process account inquiries, and provide financial advice through AI-powered chatbots.",
      icon: (
        <i
          className="icon-ai-ml-development-services-finance"
          style={{
            fontSize: "var(--icon-size)",
            width: "var(--icon-size)",
            height: "var(--icon-size)",
          }}
        />
      ),
    },
   
    {
      title: "Education",
      description:
        "AI chatbots can assist in answering student queries, providing course information, and automating administrative tasks.",
      icon: (
        <i
          className="icon-ai-chatbot-developmet-education"
          style={{
            fontSize: "var(--icon-size)",
            width: "var(--icon-size)",
            height: "var(--icon-size)",
          }}
        />
      ),
    },
    {
      title: "Travel & Hospitality",
      description:
        "Enhance customer service by helping travelers book flights, hotels, and provide real-time updates on their travel plans.",
      icon: (
        <i
          className="icon-ai-chatbot-developmet-travel-hospitality"
          style={{
            fontSize: "var(--icon-size)",
            width: "var(--icon-size)",
            height: "var(--icon-size)",
          }}
        />
      ),
    },
    {
      title: "Real Estate",
      description:
        "AI chatbots can assist potential buyers with property searches, virtual tours, and personalized recommendations.",
      icon: (
        <i
          className="icon-ai-chatbot-developmet-realestate"
          style={{
            fontSize: "var(--icon-size)",
            width: "var(--icon-size)",
            height: "var(--icon-size)",
          }}
        />
      ),
    },
  ]

  return (
    <div
      className="min-h-screen flex items-center justify-center text-white bg-cover bg-center relative"
      style={{
        backgroundImage: `url("https://webmobtechcdn.nyc3.cdn.digitaloceanspaces.com/wmt_v4/2025/01/businessman-search-new-opportunities-international-business-typing-laptop-background-world-map-hologram-scaled.jpg")`,
      }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      <div className="relative z-10 p-6 md:p-16 rounded-lg w-full">
        {/* Title */}
        <h1 className="text-3xl md:text-5xl font-bold my-4 md:mb-6 text-center text-white">
          Industries We Serve with AI Chatbot Development
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-gray-300 text-center  mx-auto mb-8">
          AI chatbots are transforming businesses across various industries.
          Here are some of the sectors we specialize in:
        </p>

        {/* Industry Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 w-full mx-auto gap-4">
          {industries.map((industry, index) => (
            <div className="feature-tag">
              <div className="flex flex-col items-start h-full">
                <div
                  className="w-20 h-20 md:w-24 md:h-24 lg:w-26 lg:h-26 rounded-2xl text-white flex items-center justify-center mb-6 text-2xl md:text-4xl lg:text-6xl"
                  style={{
                    background: "rgba(255, 255, 255, 0.10)",
                  }}
                >
                  {industry.icon}
                </div>
                <h3 className="text-xl lg:text-2xl font-bold text-white mb-4">
                  {industry.title}
                </h3>
                <div className="text-left font-normal text-lg text-white overflow-hidden">
                  {industry.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AiChatbotDevFeature
